import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'

const investingPalette = {
  ColorPaletteInvestingLightFocus: '#6520BC',
  ColorPaletteInvestingLight: '#862AFB',
  ColorPaletteInvestingLightActive: '#A45FFC',

  ColorPaletteInvestingDarkFocus: '#7D39BE',
  ColorPaletteInvestingDark: '#A74CFD',
  ColorPaletteInvestingDarkActive: '#BD79FD',

  ColorPaletteInvestingDisabled: '#FFFFFF',
} as const

const investingColors = {
  active: {
    light: investingPalette.ColorPaletteInvestingLightActive,
    dark: investingPalette.ColorPaletteInvestingDarkActive,
  },
  disabled: {
    light: investingPalette.ColorPaletteInvestingDisabled,
    dark: investingPalette.ColorPaletteInvestingDisabled,
  },
  primaryButtonActive: {
    light: investingPalette.ColorPaletteInvestingLightActive,
    dark: investingPalette.ColorPaletteInvestingDarkActive,
  },
  primaryButtonHover: {
    light: investingPalette.ColorPaletteInvestingLightActive,
    dark: investingPalette.ColorPaletteInvestingDarkActive,
  },
  primary: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  primaryButtonBackground: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  tint: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  progressBarFill: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  outlineButtonSelectedBorder: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
} as ThemeColorsOverride

export const investingArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  buttonProminentBackgroundDefault: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  buttonProminentBackgroundDisabled: {
    light: `${investingPalette.ColorPaletteInvestingLight}4D`,
    dark: `${investingPalette.ColorPaletteInvestingDark}4D`,
  },
  buttonProminentBackgroundHover: {
    light: investingPalette.ColorPaletteInvestingLightActive,
    dark: investingPalette.ColorPaletteInvestingDarkActive,
  },
  buttonProminentBackgroundPressed: {
    light: investingPalette.ColorPaletteInvestingLightActive,
    dark: investingPalette.ColorPaletteInvestingDarkActive,
  },
  buttonSubtleBackgroundFocus: {
    light: `${investingPalette.ColorPaletteInvestingLight}1A`,
    dark: `${investingPalette.ColorPaletteInvestingDark}1A`,
  },
  buttonSubtleBackgroundHover: {
    light: `${investingPalette.ColorPaletteInvestingLight}33`,
    dark: `${investingPalette.ColorPaletteInvestingDark}33`,
  },
  buttonSubtleBackgroundPressed: {
    light: `${investingPalette.ColorPaletteInvestingLight}33`,
    dark: `${investingPalette.ColorPaletteInvestingDark}33`,
  },
  buttonSubtleIconDefault: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  buttonSubtleIconPressed: {
    light: investingPalette.ColorPaletteInvestingLightFocus,
    dark: investingPalette.ColorPaletteInvestingDarkFocus,
  },
  buttonSubtleTextDefault: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  buttonSubtleTextPressed: {
    light: investingPalette.ColorPaletteInvestingLightFocus,
    dark: investingPalette.ColorPaletteInvestingDarkFocus,
  },
  checkboxActiveBackgroundDefault: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  checkboxActiveBackgroundDisabled: {
    light: `${investingPalette.ColorPaletteInvestingLight}4D`,
    dark: `${investingPalette.ColorPaletteInvestingDark}4D`,
  },
  checkboxActiveBackgroundPressed: {
    light: `${investingPalette.ColorPaletteInvestingLight}66`,
    dark: `${investingPalette.ColorPaletteInvestingDark}66`,
  },
  inputBorderSelectedDefault: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  inputBorderSelectedPressed: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  inputCursor: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  radioActiveBackgroundPressed: {
    light: `${investingPalette.ColorPaletteInvestingLight}66`,
    dark: `${investingPalette.ColorPaletteInvestingDark}66`,
  },
  radioActiveBorderDefault: {
    light: investingPalette.ColorPaletteInvestingLight,
    dark: investingPalette.ColorPaletteInvestingDark,
  },
  radioActiveBorderDisabled: {
    light: `${investingPalette.ColorPaletteInvestingLight}4D`,
    dark: `${investingPalette.ColorPaletteInvestingDark}4D`,
  },
}

export default investingColors
